const comments = [
  {
    id: 1,
    avatar: '匿',
    name: '吃瓜一线网友',
    time: '3小时前',
    content: '这个网站真的太及时了，我之前收藏的地址全挂了，终于找到一个靠谱的吃瓜爆料网入口。每天上班摸鱼必刷，反差视频区是永远的神！',
    likes: '2.3万',
  },
  {
    id: 2,
    avatar: '瓜',
    name: '八卦小能手',
    time: '6小时前',
    content: '吃瓜爆料网App太好用了，推送速度比微博还快。上次某明星塌房的料我比热搜早了半小时看到，在群里装了一把大佬，太爽了哈哈。',
    likes: '1.8万',
  },
  {
    id: 3,
    avatar: '爆',
    name: '圈内知情人士',
    time: '12小时前',
    content: '作为一个在娱乐圈边缘混的人，有些料确实是真的。吃瓜爆料网的信息整合能力很强，虽然不全是实锤，但作为吃瓜渠道已经比大部分平台靠谱了。',
    likes: '3.1万',
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-100">
      <div className="px-4 md:px-6 max-w-7xl mx-auto">
        <div className="mb-10">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-2">读者热评</h2>
          <p className="text-sm text-foreground-500">吃瓜群众的真实声音</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {comments.map((comment) => (
            <div key={comment.id} className="bg-background-50 rounded-xl border border-background-200/70 p-5">
              <div className="flex items-center gap-3 mb-3">
                <div className="w-10 h-10 rounded-full bg-accent-100 flex items-center justify-center">
                  <span className="text-sm font-semibold text-accent-600">{comment.avatar}</span>
                </div>
                <div>
                  <div className="text-sm font-semibold text-foreground-800">{comment.name}</div>
                  <div className="text-xs text-foreground-400">{comment.time}</div>
                </div>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed mb-3">
                &ldquo;{comment.content}&rdquo;
              </p>
              <div className="flex items-center gap-1 text-xs text-foreground-400">
                <i className="ri-thumb-up-line"></i>
                <span>{comment.likes}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}